import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ThemeLanguageControls from "@/components/common/ThemeLanguageControls";
import HeaderAccountMenu from "./HeaderAccountMenu";
import NotificationBell from "./NotificationBell";
function PlatformAppBar({ onMenuClick, drawerWidth = 0 }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileSearch, setMobileSearch] = useState(false);

  const searchPaperSx = {
    display: "flex",
    alignItems: "center",
    px: 1.5,
    py: 0.5,
    borderRadius: 2.5,
    bgcolor: (th) =>
      th.palette.mode === "dark"
        ? "rgba(255,255,255,0.05)"
        : "rgba(15,23,42,0.04)",
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      color="inherit"
      sx={{
        width: { xs: "100%", md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        zIndex: (th) => th.zIndex.drawer + 1,
        bgcolor: "background.paper",
        borderBottom: (th) => `1px solid ${th.palette.divider}`,
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 60, md: 68 }, px: { xs: 1.5, md: 3 }, gap: 1 }}>
        <IconButton
          onClick={onMenuClick}
          sx={{ display: { md: "none" } }}
          edge="start"
          aria-label="Open navigation"
        >
          <MenuIcon />
        </IconButton>
        <Paper
          elevation={0}
          sx={{
            ...searchPaperSx,
            display: { xs: "none", sm: "flex" },
            width: { sm: 220, md: 300 },
          }}
        >
          <SearchIcon fontSize="small" sx={{ color: "text.disabled", mr: 1 }} />
          <InputBase
            placeholder={t("common.searchPlaceholder")}
            sx={{ flex: 1, fontSize: "0.875rem" }}
          />
        </Paper>
        <IconButton
          sx={{ display: { sm: "none" } }}
          onClick={() => setMobileSearch((s) => !s)}
          aria-label={t("common.search")}
        >
          <SearchIcon fontSize="small" />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <ThemeLanguageControls compact={!isMdUp} />
        <NotificationBell />
        <HeaderAccountMenu variant="platform" />
      </Toolbar>
      <Collapse in={mobileSearch} sx={{ display: { sm: "none" } }}>
        <Box sx={{ px: 1.5, pb: 1.5 }}>
          <Paper elevation={0} sx={{ ...searchPaperSx, width: "100%" }}>
            <SearchIcon fontSize="small" sx={{ color: "text.disabled", mr: 1 }} />
            <InputBase
              placeholder={t("common.searchPlaceholder")}
              sx={{ flex: 1, fontSize: "0.875rem" }}
            />
          </Paper>
        </Box>
      </Collapse>
    </AppBar>
  );
}

export { PlatformAppBar };
